import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { misc } from '../services/api';
import { Flame, BookOpen } from 'lucide-react';

const MEDAL = ['text-yellow-400', 'text-gray-300', 'text-amber-600'];

export const TopReadersBoard = ({ meId }) => {
  const [data, setData] = useState(null);
  useEffect(() => { misc.topReaders().then(setData).catch(() => setData({ readers: [] })); }, []);
  if (!data) return <div className="pbb-card h-40 animate-pulse" data-testid="top-readers-loading"/>;
  return (
    <div className="pbb-card p-5" data-testid="top-readers-board">
      <div className="flex items-center gap-2 flex-wrap">
        <Flame className="text-orange-400" size={18}/>
        <h2 className="text-base md:text-lg font-bold">Top Readers This Week</h2>
        <span className="text-xs text-gray-500">Week of {new Date(`${data.weekStart}T12:00:00`).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })} · resets Monday</span>
      </div>
      {data.readers.length === 0 ? (
        <div className="mt-4 text-sm text-gray-400" data-testid="top-readers-empty">
          No readers yet this week. <Link to="/news" className="text-green-400 underline">Read an article and answer its question</Link> to claim the top spot.
        </div>
      ) : (
        <ol className="mt-4 divide-y divide-[#1a1a1a]">
          {data.readers.map(r => (
            <li key={r.id} data-testid={`top-reader-${r.rank}`}
              className={`flex items-center gap-3 py-2.5 ${r.id === meId ? 'bg-green-500/5 -mx-2 px-2 rounded-lg' : ''}`}>
              <span className={`w-6 text-center font-bold ${MEDAL[r.rank - 1] || 'text-gray-500'}`}>{r.rank}</span>
              <div className="w-8 h-8 rounded-full bg-[#13261a] overflow-hidden flex items-center justify-center text-xs font-semibold text-green-300 shrink-0">
                {r.avatar ? <img src={r.avatar} alt="" className="w-full h-full object-cover"/> : r.name.slice(0, 1)}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate">{r.name}{r.id === meId && <span className="text-green-400 text-xs ml-1">(you)</span>}</div>
                <div className="text-[11px] text-gray-500 inline-flex items-center gap-1"><BookOpen size={10}/> {r.answers} answered · {r.correct} correct</div>
              </div>
              <div className="text-right">
                <div className="text-sm font-semibold text-gray-100">{r.daysThisWeek}/7 days</div>
                <div className="text-[11px] text-orange-400 inline-flex items-center gap-1"><Flame size={10}/> {r.streak}-day streak</div>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
